import { h } from 'vue';
import MaterialSymbolsIcon from '~/components/common/icon-sets/materialSymbolsIcon';

const aliases = {
  collapse: 'keyboard_arrow_up',
  complete: 'check',
  cancel: 'cancel',
  close: 'close',
  delete: 'cancel no-fill',
  clear: 'close',
  success: 'check_circle',
  info: 'info no-fill',
  warning: 'warning no-fill',
  error: 'error no-fill',
  eyeDropper: 'colorize',
  prev: 'chevron_left',
  next: 'chevron_right',
  checkboxOn: 'check_box',
  checkboxOff: 'check_box_outline_blank',
  checkboxIndeterminate: 'indeterminate_check_box',
  delimiter: 'circle',
  sortAsc: 'arrow_upward',
  sortDesc: 'arrow_downward',
  expand: 'keyboard_arrow_down',
  menu: 'menu',
  subgroup: 'arrow_drop_down',
  dropdown: 'arrow_drop_down',
  radioOn: 'radio_button_checked',
  radioOff: 'radio_button_unchecked',
  edit: 'edit',
  ratingEmpty: 'star no-fill',
  ratingFull: 'star',
  ratingHalf: 'star_half',
  loading: 'cached',
  first: 'first_page',
  last: 'last_page',
  unfold: 'unfold_more',
  file: 'attach_file',
  plus: 'add',
  minus: 'remove',
};

/**
 * Material Symbols rounded icon set
 */
const ms = {
  component: (props) => h(MaterialSymbolsIcon, props),
};

export { aliases, ms };
